import { applyMiddleware, createStore, compose } from 'redux'
import thunk from 'redux-thunk'

const middlewares = applyMiddleware(thunk)
const enhancer = compose(
    middlewares
)

export default function (reducer, initialState) {
    return createStore(reducer, initialState, enhancer)
}



// WEBPACK FOOTER //
// ./react/store/createStore.prod.js